<page-header [title]="'profilUser.donneesConnexion.title' | translate" (onGoBack)="onGoBack()"></page-header>

<!--Bloc de changement de mot de passe-->
<change-password></change-password>